export default "__VITE_ASSET__ae3b1a2b__"